import React, { useState, useEffect, useRef } from "react";
import Breadcrumb from "./Breadcrumb";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Formik, FieldArray } from "formik";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { ToastContainer } from "react-toastify";
import * as Yup from "yup";
import { ProductService } from "../../../services/product-service";
import Select from "react-select";
import { ReportService } from "../../../services/reports-service";
import { GdnService } from "../../../services/gdn-service";


export const Addgdncontent = (props) => {
  var bodyFormData = new FormData();

  const formRef = useRef();

  const [submitloading, setSubmitLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [publishers, setPublishers] = useState([]);
  const [publisherId, setPublisherId] = useState("");
  const [totalPrice, setTotalPrice] = useState(0);


  const fetchStaticData = async () => {
    try {
      const staticDetails = await ReportService.staticDetails();
      setPublishers(staticDetails.publishers);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations

    setSubmitLoading(false);
    bodyFormData.append("publisher_id", values.publisher_id);
    bodyFormData.append("invoice_number", values.invoice_number);
    bodyFormData.append("total_price", values.total_price);
    bodyFormData.append("comment", values.comment);
    bodyFormData.append("product_data", JSON.stringify(values.product_data));

    try {
      await GdnService.gdnCreate(values);
      setSubmitLoading(true);
      notify("GDN successfully created");
      formRef.current.resetForm();
    } catch (err) {
      console.log(err)
      setSubmitLoading(true);
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  useEffect(() => {
    productDetailsSearch();
  }, [publisherId]);

  const productDetailsSearch = async () => {
    try {
      if(publisherId){
        const result = await ProductService.activeProductDetailsSearch([{"product_group_type": "single"},{"status": "ACTIVE"}, {"publisherId": publisherId}, {"stock": "instock"}]);
        setProducts(result.results);
      }else{
        setProducts([]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchStaticData();
  },[])

  

  let ProductOptions = products.map((product) => ({
    value: product.id,
    label: product.name,
    keyword: product.name.toLowerCase(),
  }));

  let publisherOptions = publishers.map((publisher) => ({
    value: publisher.id,
    label: publisher.name,
  }));

  const filterProductOption = (option, rawInput) => {
    const search = rawInput.toLowerCase().trim();
    const keywords = search.split(/\s+/); // split by spaces
    const optionText = option.data.keyword;
    
    return keywords.every((keyword) => optionText.includes(keyword));
  };

  const calculateLineTotal = (quantity, unit_price, discount_percentage) => {
    const total = quantity * unit_price;
    const discount = (total * discount_percentage) / 100;
    return total - discount;
  };

  const calculateTotalPrice = (products) => {
    return products.reduce((sum, product) => sum + (Number(product.line_total) || 0), 0);
  };

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div>
          <ToastContainer />
        </div>
        <div className="col-md-12">
          <Breadcrumb />
        </div>

        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Add Goods Dispatch Note(GDN) </h6>
            </div>
            <div className="ms-panel-body">
              <div className="row">
                <div className="col-sm-12">
                  <Formik
                    initialValues={{
                      publisher_id: "",
                      invoice_number: "",
                      total_price: "",
                      comment: "",
                      sent_date: "",
                      product_data: [],
                    }}
                    validationSchema={Yup.object().shape({
                      publisher_id: Yup.string().required("Required"),
                      invoice_number: Yup.string().required("Required"),
                      total_price: Yup.string().required("Required"),
                      sent_date: Yup.string().required("Required"),
                      product_data: Yup.array()
                        .required("Must have products")
                        .min(1, "Minimum of 1 product"),
                    })}
                    onSubmit={onSubmitForm}
                    validate={(values) => {
                      values.total_price = calculateTotalPrice(values.product_data);
                    }}
                    innerRef={formRef}
                    render={({
                      errors,
                      handleBlur,
                      handleChange,
                      touched,
                      values,
                      submitForm,
                      isValid,
                      setFieldValue,
                    }) => (
                      <div>
                        <div className="form-row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom08">Supplier Name</label>
                            
                              <Select
                                options={publisherOptions}
                                onChange={(selectedOption)=>{
                                  setFieldValue('publisher_id', selectedOption ? selectedOption.value : "")
                                  setPublisherId(selectedOption ? selectedOption.value : "")
                                  setFieldValue('product_data', []); // Clear the product data
                                  setFieldValue('total_price', 0);
                                }}
                                isClearable
                                placeholder="Select Publisher"
                                value={publisherOptions.find(option => option.value === values.publisher_id)}
                              />
                        
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.publisher_id && errors.publisher_id}
                            </div>
                          </div>

                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom08">
                              Invoice Number
                            </label>
                            <div className="input-group">
                              <input
                                name="invoice_number"
                                type="text"
                                className="form-control"
                                id="invoiceNumber"
                                placeholder=""
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.invoice_number}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.invoice_number && errors.invoice_number}
                            </div>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom08">
                              Total Price
                            </label>
                            <div className="input-group">
                              <input
                                name="total_price"
                                type="number"
                                className="form-control"
                                id="totalpriceId"
                                placeholder=""
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.total_price} 
                                readOnly
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.total_price && errors.total_price}
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom08">
                              Dispatch Date
                            </label>
                            <div className="input-group">
                              <input
                                name="sent_date"
                                type="date"
                                className="form-control"
                                id="dateid"
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.sent_date}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.sent_date && errors.sent_date}
                            </div>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="col-md-12 mb-3">
                            <label htmlFor="validationCustom08">
                              Comment
                            </label>
                            <div className="input-group">
                              <textarea
                                name="comment"
                                type="text"
                                className="form-control"
                                id="commentid"
                                placeholder="Comment"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.comment}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.comment && errors.comment}
                            </div>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="col-md-12 mb-3">
                            <label htmlFor="validationCustom25">Products</label>
                            <FieldArray
                              name="product_data"
                              render={(arrayHelpers) => (
                                <div>
                                  {values.product_data.map((product, index) => (
                                    <div key={index}>
                                      <div className="form-row">
                                        <div className="col-md-4 mb-3">
                                            <Select
                                              options={ProductOptions}
                                              onChange={(selectedOption)=>{
                                                const productPrice = selectedOption ? products.find(p => p.id === selectedOption.value)?.price : "";
                                                const availableStock = selectedOption ? products.find(p => p.id === selectedOption.value)?.stock : "";
                                                
                                                setFieldValue(`product_data.${index}.product_id`, selectedOption ? selectedOption.value : "")
                                                setFieldValue(`product_data.${index}.unit_price`, productPrice || "");
                                                setFieldValue(`product_data.${index}.stock`, availableStock || 0);
                                               
                                                const quantity = values.product_data[index].quantity || 0;
                                                const discount_percentage = values.product_data[index].discount_percentage || 0;
                                                const line_total = calculateLineTotal(quantity, productPrice || 0, discount_percentage);
                                                setFieldValue(`product_data.${index}.line_total`, line_total);
                                                setFieldValue("total_price", calculateTotalPrice(values.product_data));
                                              }}
                                              isClearable
                                              placeholder="Select Product"
                                              filterOption={filterProductOption}
                                              value={ProductOptions.find(option => option.value === values.product_data[index].product_id)}
                                            />
                                        </div>
                                        <div className="col-md-1 mb-3">
                                          <label className="form-label mt-2 text-success">
                                            Available {values.product_data[index].stock}
                                          </label>
                                        </div>
                                        <div className="col-md-2 mb-3">
                                          <div className="input-group">
                                            <input
                                              onChange={(e) => {
                                                handleChange(e);
                                                const quantity = e.target.value;
                                                const unit_price = values.product_data[index].unit_price;
                                                const discount_percentage = values.product_data[index].discount_percentage;
                                                const line_total = calculateLineTotal(quantity, unit_price, discount_percentage);
                                                setFieldValue(`product_data.${index}.line_total`, line_total);
                                                setFieldValue('total_price', calculateTotalPrice(values.product_data));
                                              }}
                                              onBlur={handleBlur}
                                              type="number"
                                              className="form-control"
                                              id="validationCustom26"
                                              placeholder="Quantity"
                                              required
                                              name={`product_data[${index}].quantity`}
                                              value={values.product_data[index].quantity}
                                            />
                                          </div>
                                        </div>

                                        <div className="col-md-1 mb-3">
                                          <div className="input-group">
                                            <input
                                              // onChange={(e) => {
                                              //   handleChange(e);
                                              //   const quantity = values.product_data[index].quantity;
                                              //   const unit_price = e.target.value;
                                              //   const discount_percentage = values.product_data[index].discount_percentage;
                                              //   const line_total = calculateLineTotal(quantity, unit_price, discount_percentage);
                                              //   setFieldValue(`product_data.${index}.line_total`, line_total);
                                              //   setFieldValue('total_price', calculateTotalPrice(values.product_data));
                                              // }}
                                              onBlur={handleBlur}
                                              type="number"
                                              className="form-control"
                                              id="validationCustom27"
                                              placeholder="unit price"
                                              required
                                              name={`product_data[${index}].unit_price`}
                                              value={values.product_data[index].unit_price}
                                              readOnly
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-1 mb-3">
                                          <div className="input-group">
                                            <input
                                              onChange={(e) => {
                                                handleChange(e);
                                                const quantity = values.product_data[index].quantity;
                                                const unit_price = values.product_data[index].unit_price;
                                                const discount_percentage = e.target.value;
                                                const line_total = calculateLineTotal(quantity, unit_price, discount_percentage);
                                                setFieldValue(`product_data.${index}.line_total`, line_total);
                                                setFieldValue('total_price', calculateTotalPrice(values.product_data));
                                              }}
                                              onBlur={handleBlur}
                                              type="number"
                                              className="form-control"
                                              id="validationCustom27"
                                              placeholder="Discount %"
                                              required
                                              name={`product_data[${index}].discount_percentage`}
                                              value={values.product_data[index].discount_percentage}
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-2 mb-3">
                                          <div className="input-group">
                                          <input
                                              type="number"
                                              className="form-control"
                                              id="validationCustom27"
                                              placeholder="Line total"
                                              required
                                              name={`product_data[${index}].line_total`}
                                              value={values.product_data[index].line_total}
                                              readOnly
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-1 mb-3">
                                          <button
                                            type="button"
                                            className="ms-btn-icon btn-primary"
                                            name="button"
                                            onClick={() => {
                                              arrayHelpers.remove(index);
                                              setFieldValue("total_price", calculateTotalPrice(values.product_data.filter((_, i) => i !== index)));
                                            }}
                                            style={{
                                              marginBottom: "2vh",
                                              backgroundColor: "red",
                                            }}
                                          >
                                            -
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                  <button
                                    type="button"
                                    className="ms-btn-icon btn-primary"
                                    name="button"
                                    onClick={() =>
                                      arrayHelpers.push({
                                        product_id: "",
                                        quantity: '',
                                        unit_price: '',
                                        discount_percentage: '',
                                        line_total: '',
                                      })
                                    }
                                    style={{ marginBottom: "1vh" }}
                                  >
                                    +
                                  </button>
                                </div>
                              )}
                            />
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {errors.product_data}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 mb-3">
                          <div className="col-md-2" hidden={submitloading}>
                            <div className="spinner spinner-7">
                              <div className="bounce1" />
                              <div className="bounce2" />
                              <div className="bounce3" />
                            </div>
                          </div>
                        </div>

                        <button
                          type="button"
                          className="btn btn-primary shadow-none float-right"
                          onClick={submitForm}
                        >
                          Add
                        </button>
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addgdncontent;
